import { render } from "./SmallBanner.vue?vue&type=template&id=646eb5cb"
import script from "./SmallBanner.vue?vue&type=script&lang=js"
export * from "./SmallBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__